import styled from 'styled-components';
import { ContainerColumnStart, ContainerColumnWithoutWidth, LinkButton, SectionTitleLink } from '../../styles/Common';
import { deviceMax } from '../../styles/MediaQuery';
import { containerWidth, greyBackground } from '../../styles/Variables';

export const AboutUsWrapper = styled(ContainerColumnWithoutWidth)`
    margin: 2rem 0;
`;

export const ContentContainer = styled(ContainerColumnStart)`
    width: ${containerWidth};

    @media ${deviceMax.laptop} {
        width: 100%;

        * {
            padding: 0 10px;
        }
    }
`;

export const DescriptionContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;

    @media ${deviceMax.laptop} {
        flex-direction: column;
    }
`;

export const Title = styled(SectionTitleLink)``;

export const DescriptionWrapper = styled(ContainerColumnWithoutWidth)`
    width: 100%;
    background: ${greyBackground};
`;

export const DescriptionText = styled.p`
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-family: Arial, Helvetica, sans-serif;
    padding: 0;
`;

export const Button = styled(LinkButton)`
    margin-top: 0.5rem;
    margin-bottom: 1rem;

    @media ${deviceMax.laptop} {
        margin: 1rem 10px;
        padding: 0.75em 1.875em;
    }
`;

export const Image = styled.img`
    width: 200px;
    min-width: 200px;
    height: auto;
    margin-right: 1rem;

    @media ${deviceMax.laptop} {
        margin-right: 0;
    }
`;
